<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <span class="sr-only">{{ srLabel }}</span>
    <div
      v-show="loadingPosts"
      class="loading-posts"
    >
      <div class="lds-ring">
        <div /><div /><div /><div />
      </div>
    </div>
    <div
      v-if="cookieConsented && !loading"
      class="social-posts-carousel social-posts-carousel--swiper"
    >
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in posts"
          :key="index"
          class="swiper-slide"
          tabindex="0"
          :aria-label="item.srLabel"
          @focus="goToSlide(index)"
          v-html="item.embedded"
        />
      </div>
      <div
        tabindex="-1"
        class="swiper-button-prev button-nav button-nav--prev"
      >
        <svg><use xlink:href="#chevron-left" /></svg>
      </div>
      <div
        tabindex="-1"
        class="swiper-button-next button-nav button-nav--next"
      >
        <svg><use xlink:href="#chevron-right" /></svg>
      </div>
    </div>
    <div v-if="!cookieConsented && !loading">
      <onetrust-blocker />
    </div>
    <div v-if="error && !loading">
      <slot name="on-error" />
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'social-posts-carousel',
  props: {
    urlApi: {
      type: String,
      required: true
    },
    apiKey: {
      type: String,
      required: true
    },
    srLabel: {
      type: String,
      required: false,
      default: 'Carousel'
    },
    isShuffled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      swiper: null,
      sizeItem: 0,
      totalItems: 0,
      cookieConsented: false,
      loading: true,
      loadingPosts: false,
      error: false,
      posts: []
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'marketing',
      'date'
    ])
  },
  watch: {
    date() {
      this.loading = false
    },
    marketing() {
      this.loading = false
      if (this.marketing) {
        this.cookieConsented = true
        this.getData()
      } else {
        this.cookieConsented = false
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  methods: {
    shuffle(array) {
      let currentIndex = array.length
      let temporaryValue
      let randomIndex
      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }
      return array
    },
    injectSocialScripts() {
      const ensureScript = (id, src) => {
        if (document.getElementById(id)) return
        const s = document.createElement('script')
        s.id = id
        s.async = true
        s.src = src
        document.body.appendChild(s)
      }

      ensureScript('ig-embed', 'https://www.instagram.com/embed.js')
      ensureScript('tw-widgets', 'https://platform.twitter.com/widgets.js')

      if (!document.getElementById('fb-root')) {
        const fbRoot = document.createElement('div')
        fbRoot.id = 'fb-root'
        document.body.appendChild(fbRoot)
      }

      ensureScript('fb-sdk', 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2')
    },
    getData() {
      this.loadingPosts = true
      axios.post(this.urlApi, {
        containerId: this.apiKey
      })
        .then(response => {
          this.loadingPosts = false
          if (response.data.posts && response.data.posts.length > 0) {
            if (this.isShuffled) {
              this.posts = this.shuffle(response.data.posts)
            } else {
              this.posts = response.data.posts
            }
            this.totalItems = this.posts.length
            this.$nextTick(() => {
              this.injectSocialScripts()
              this.createSwiper()
            })
          } else {
            this.error = true
          }
        })
        .catch(() => {
          this.loadingPosts = false
          this.error = true
        })
    },
    onResize() {
      if (this.swiper) {
        this.swiper.virtual.update()
      }
    },
    createSwiper() {
      this.swiper = new Swiper('.social-posts-carousel--swiper', {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: false,
        breakpointsInverse: true,
        breakpoints: {
          425: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          }
        },
        navigation: {
          nextEl: '.button-nav--next',
          prevEl: '.button-nav--prev',
        }
      })
      this.onResize()
    },
    goToSlide(i) {
      this.swiper.slideTo(i)
    }
  }
}
</script>
